import React, {Component} from 'react';
import {getOS} from "../utis/util";
import {PlatformType} from "../utis/customEnum";

export default class FAQ extends Component {

    state = {
        isIOSTipsCollapsed: getOS() !== PlatformType.iOS,
        isAndroidTipsCollapsed: getOS() !== PlatformType.android,
    }

    toggleIOSTipsCollapsed = () => {
        const {isIOSTipsCollapsed} = this.state
        this.setState({isIOSTipsCollapsed: !isIOSTipsCollapsed})
    }

    toggleAndroidTipsCollapsed = () => {
        const {isAndroidTipsCollapsed} = this.state
        this.setState({isAndroidTipsCollapsed: !isAndroidTipsCollapsed})
    }

    renderGrayArrow() {
        return (
            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.34317 0.757324L0.928955 2.17154L8.00001 9.24263L15.0711 2.17157L13.6569 0.757353L8.00003 6.41419L2.34317 0.757324Z" fill="#A1A1A1"/>
            </svg>
        )
    }

    renderBlackArrow() {
        return (
            <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.6569 8.58953L15.0711 7.17532L8.00007 0.104248L0.928955 7.17535L2.34317 8.58956L8.00006 2.93267L13.6569 8.58953Z" fill="#414141"/>
            </svg>
        )
    }

    renderAndroidTips() {
        const {isAndroidTipsCollapsed} = this.state
        if (isAndroidTipsCollapsed) {
            return (
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 20}} onClick={this.toggleAndroidTipsCollapsed}>
                    {this.renderGrayArrow()}
                    <span style={{fontSize: 16, fontWeight: 400, marginLeft: 16}}>{'For Android User'}</span>
                </div>
            )
        } else {
            return (
                <div style={{display: 'flex', flexDirection: 'column', padding: 20, borderRadius: 20, backgroundColor: '#EEF3F9'}}>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: 10, paddingBottom: 10}} onClick={this.toggleAndroidTipsCollapsed}>
                        {this.renderBlackArrow()}
                        <span style={{fontSize: 16, fontWeight: 700, marginLeft: 16}}>{'For Android User'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', padding: 10}}>
                        <span style={{fontSize: 16, fontWeight: 400, marginBottom: 8}}>{'Click on the lock icon beside your address bar.'}</span>
                        <img style={{height: 40}} src={require('../assets/faq/android_tips_01.png')} alt={''}/>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24, marginBottom: 8}}>{'Then Click on Permissions and enable camera, microphone and sound.'}</span>
                        <img style={{height: 270}} src={require('../assets/faq/android_tips_02.png')} alt={''}/>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24, marginBottom: 8}}>{'If the issue persists, go to settings, go to Notification.'}</span>
                        <img style={{height: 350}} src={require('../assets/faq/android_tips_03.png')} alt={''}/>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24, marginBottom: 8}}>{'Turn off Bubbles.'}</span>
                        <img style={{height: 380}} src={require('../assets/faq/android_tips_04.png')} alt={''}/>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24, marginBottom: 24}}>
                            {`Now go back to the telehealth page and `}
                            <span style={{fontWeight: 700}}>{'reload'}</span>
                            {` the page`}.
                        </span>
                        <span style={{fontSize: 16, fontWeight: 400}}>
                            {`If you are still having issue with your telehealth visit, please email us at `}
                            <a style={{textDecorationLine: 'underline'}} href={'mailto:digitalhealth@mdland.com'}>{'digitalhealth@mdland.com'}</a>
                            {`, we will try our best to help you!`}
                        </span>
                    </div>
                </div>
            )
        }
    }

    renderIOSTips() {
        const {isIOSTipsCollapsed, isAndroidTipsCollapsed} = this.state
        if (isIOSTipsCollapsed) {
            return (
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 20}} onClick={this.toggleIOSTipsCollapsed}>
                    {this.renderGrayArrow()}
                    <span style={{fontSize: 16, fontWeight: 400, marginLeft: 16}}>{'For iOS User'}</span>
                </div>
            )
        } else {
            return (
                <div style={{display: 'flex', flexDirection: 'column', padding: 20, borderRadius: 20, marginTop: isAndroidTipsCollapsed ? 0 : 20, backgroundColor: '#EEF3F9'}}>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: 10, paddingBottom: 10}} onClick={this.toggleIOSTipsCollapsed}>
                        {this.renderBlackArrow()}
                        <span style={{fontSize: 16, fontWeight: 700, marginLeft: 16}}>{'For iOS User'}</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', padding: 10}}>
                        <span style={{fontSize: 16, fontWeight: 400, marginBottom: 8}}>{'Allow Microphone and Camera access when joining.'}</span>
                        <img style={{height: 550}} src={require('../assets/faq/ios_tips_01.png')} alt={''}/>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24}}>{'If you cancelled the access for the first time. Follow the instructions below:'}</span>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24, marginBottom: 8}}>{'Click on the AA icon beside the address bar.'}</span>
                        <img style={{height: 400}} src={require('../assets/faq/ios_tips_02.png')} alt={''}/>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24, marginBottom: 8}}>{'Click on Website Settings.'}</span>
                        <img style={{height: 400}} src={require('../assets/faq/ios_tips_03.png')} alt={''}/>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24, marginBottom: 8}}>
                            {`Change your Camera, Microphone, Location access from Ask to `}
                            <span style={{fontWeight: 700}}>{'Allow'}.</span>
                        </span>
                        <img style={{height: 320}} src={require('../assets/faq/ios_tips_04.png')} alt={''}/>
                        <img style={{marginTop: 8, height: 360}} src={require('../assets/faq/ios_tips_05.png')} alt={''}/>
                        <span style={{fontSize: 16, fontWeight: 400, marginTop: 24, marginBottom: 24}}>
                            {`Now go back to the telehealth page and `}
                            <span style={{fontWeight: 700}}>{'reload'}</span>
                            {` the page`}.
                        </span>
                        <span style={{fontSize: 16, fontWeight: 400}}>
                            {`If you are still having issue with your telehealth visit, please email us at `}
                            <a style={{textDecorationLine: 'underline'}} href={'mailto:digitalhealth@mdland.com'}>{'digitalhealth@mdland.com'}</a>
                            {`, we will try our best to help you!`}
                        </span>
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div style={{display: 'flex', flexDirection: 'column', padding: 10, backgroundColor: 'white'}}>
                <div style={{paddingLeft: 10, paddingRight: 10}}>
                    <p style={{fontSize: 18, fontWeight: 600, color: "#365496"}}>Troubleshooting steps for Telehealth visit</p>
                </div>
                {this.renderAndroidTips()}
                {this.renderIOSTips()}
            </div>
        )
    }
}
